import React, { Component } from 'react'
import { loadApp } from 'wbap-core-commit'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'
import { UserLayout } from './components'
import { inject, observer } from 'mobx-react'

@inject('UserStore', 'RouterStore')
@observer
@withRouter
export default class Page extends Component {
  constructor (props) {
    super(props)
    this.props.RouterStore.setRouter(this.props.history, this.props.location, this.props.match)
    console.log(props)
  }

  isLogin () {
    // if (this.props.UserStore.FUSER_ID) {
    //   return loadApp('wbap-admin-main')
    // } else {
    //   return <Redirect to='/user/wbap-admin-login'/>
    // }
    return loadApp('wbap-admin-main')
  }

  render () {
    return (
      <Switch>
        <Route path='/user' render={() => <UserLayout/>}/>
        <Route exact path='/' render={() => this.isLogin()}/>
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-root/page.js